module.exports = __webpack_public_path__ + "assets/ca9fffd034b91427ca399b9a51786c77.png";